import { useEffect, useCallback } from "react";
import { useParameter, useSubscriptionProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";
import { useSlideSubtitle } from "../hooks/useSlideSubtitle";
import { ApplyParameters } from "../../../shared/components/SubscriptionProvider/SubscriptionProvider.types";

export function useSubscription() {
  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const {
    actions: { setParameters, setTitle, setSubtitle, setApplyParametersFunction },
  } = useSubscriptionProviderContext();

  const [calendar] = useParameter<number[]>("@calendar");
  const [eCalendar] = useParameter<number[]>("@e_calendar");
  const [e_countries] = useParameter<number[]>("@e_countries");

  const [commodities, setCommodities] = useParameter<number[]>("@commodities");
  const [commDisplay, setCommDisplay] = useParameter<string[]>("@commodities_display");

  useEffect(() => {
    setTitle(title);
    setSubtitle(subtitle);
    setParameters({
      "@commodities": commodities,
      "@e_countries": e_countries,
      "@e_calendar": eCalendar,
      "@commodities_display": commDisplay,
      "@calendar": calendar,
    });
  }, [title, subtitle, eCalendar, commDisplay, calendar, commodities, e_countries, setParameters]);

  const applyParameters = useCallback(
    (parameters: ApplyParameters) => {
      setCommodities((parameters["@commodities"].value as string[]).map(Number));
      setCommDisplay(parameters["@commodities_display"].value as string[]);
    },
    [setCommodities, setCommDisplay]
  );

  useEffect(() => {
    setApplyParametersFunction(applyParameters);
  }, [setApplyParametersFunction, applyParameters]);
}
